import { useEffect, useState } from "react";
import pick from "ramda/src/pick";
import Api from "../../services/Api";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import useAuth from "../../routes/login/AuthContext";
import { useNetwork } from "../../hooks/useNetwork";

import { getDefaultDate } from "../../helpers/getDefaultDate";


import type { MatchDate, Stats } from "./types";

const sortRows = (a: MatchDate, b: MatchDate) => {
  if (!a.matchingStartDate && !b.matchingStartDate) {
    return 0; 
  }
  if (!a.matchingStartDate && b.matchingStartDate) {
      return -1;
  }

  if (a.matchingStartDate && !b.matchingStartDate) {
      return 1;
  }

  if (a.matchingStartDate && b.matchingStartDate) {
    return a.matchingStartDate.diff(b.matchingStartDate);
  }
  return 0;
};

export const useMatchingRoundRows = () => {
  const { getAuthToken } = useAuth();
  const { isOpen, isPasscode, isAcc, isEntrata } = useSelectedNetworkImportTypes();
  const [{ rows, archivedRows }, setRows] = useState<{ rows: MatchDate[], archivedRows: MatchDate[] }>({ rows: [], archivedRows: [] });
  const [ stats, setStats ] = useState<Stats>({});
  const [isLoading, setIsLoading] = useState(false);
  const { selectedNetwork, getL2OptionsAsync } = useNetwork();

  const setSubnetworks = async () => 
    getL2OptionsAsync(selectedNetwork.l1Id)
      .then((l2s) => {
        const rows = l2s
        .map(
          pick(["l2Id", "l2Name", "matchingStartDate", "matchingEndDate", "activationStartDate", "activationEndDate", "matchingRoundStatus", "placementWorksheetEnabled"])
        )
        .map((r): MatchDate => ({
            ...r,
            matchingStartDate: getDefaultDate(r.matchingStartDate),
            matchingEndDate: getDefaultDate(r.matchingEndDate),
            activationStartDate: getDefaultDate(r.activationStartDate),
            activationEndDate: getDefaultDate(r.activationEndDate),
        }));
        
        const rowsSortedByStatuses = [
          ...rows.filter((r) => r.matchingRoundStatus === "MATCHING").sort(sortRows),
          ...rows.filter((r) => r.matchingRoundStatus === "UPCOMING").sort(sortRows),
          ...rows.filter((r) => r.matchingRoundStatus === "ACTIVE").sort(sortRows),
          ...rows.filter((r) => r.matchingRoundStatus === "CLOSED").sort(sortRows),
        ];

        const archivedRows = rows
          .filter((r) => r.matchingRoundStatus === "ARCHIVED")
          .sort((a, b) => b.l2Id - a.l2Id);

        setRows({
          rows: rowsSortedByStatuses,
          archivedRows,
        });
      })
      .finally(() => setIsLoading(false));

  const setL2Statistics = async (l1Id: number) => {
    const {response } = await Api.getHome(l1Id, await getAuthToken());
    if(response && response.statsBySubNetwork) {
      setStats(response.statsBySubNetwork);
    }
  };
    
  

  useEffect(() => {
    if (!selectedNetwork.l1Id) return;
    setIsLoading(true);

    setSubnetworks();
    setL2Statistics(selectedNetwork.l1Id);
    
  }, [selectedNetwork.l1Id]);

  const isLoggedInUsersCard = isPasscode || isOpen;

  return {
    isLoading,
    currecntNetwork: selectedNetwork,
    rows,
    archivedRows,
    stats,
    isLoggedInUsersCard,
    isIntegratedNetwork: isAcc || isEntrata,
  };
};
